import { supabase } from '@/lib/supabase';

export interface SellerEvent {
  id: string;
  name: string;
  description: string | null;
  start_date: string;
  end_date: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export const sellerEventsService = {
  // 모든 이벤트 가져오기
  async getAllEvents() {
    try {
      const { data, error } = await supabase
        .from('seller_events')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching seller events:', error);
        return { success: false, error: error.message };
      }

      return { success: true, data: data as SellerEvent[] };
    } catch (error) {
      console.error('Unexpected error:', error);
      return { success: false, error: '이벤트를 불러오는 중 오류가 발생했습니다' };
    }
  },

  // 활성 이벤트만 가져오기
  async getActiveEvents() {
    try {
      const now = new Date().toISOString();
      const { data, error } = await supabase
        .from('seller_events')
        .select('*')
        .eq('is_active', true)
        .lte('start_date', now)
        .gte('end_date', now)
        .order('start_date', { ascending: true });

      if (error) {
        console.error('Error fetching active seller events:', error);
        return { success: false, error: error.message };
      }

      return { success: true, data: data as SellerEvent[] };
    } catch (error) {
      console.error('Unexpected error:', error);
      return { success: false, error: '활성 이벤트를 불러오는 중 오류가 발생했습니다' };
    }
  },

  // 특정 이벤트 가져오기
  async getEventById(id: string) {
    try {
      const { data, error } = await supabase
        .from('seller_events')
        .select('*')
        .eq('id', id)
        .single();

      if (error) {
        console.error('Error fetching seller event:', error);
        return { success: false, error: error.message };
      }

      return { success: true, data: data as SellerEvent };
    } catch (error) {
      console.error('Unexpected error:', error);
      return { success: false, error: '이벤트를 불러오는 중 오류가 발생했습니다' };
    }
  }
};